import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Recommend from "@/pages/Recommend";
import Explorer from "@/pages/Explorer";
import Analytics from "@/pages/Analytics";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Launch from "@/pages/Launch";
import Community from "@/pages/Community";
import Vrat from "@/pages/Vrat";
import Enterprise from "@/pages/Enterprise";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import VerifyEmail from "@/pages/VerifyEmail";
import LearnYumo from "@/pages/LearnYumo";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment synchronously (NOT in useEffect)
  // to avoid race conditions with ProtectedRoute / AuthProvider.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Launch page has its own header/footer — render OUTSIDE the Layout wrapper.
  if (location.pathname === "/launch") {
    return <Launch />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/recommend" element={<ProtectedRoute><Recommend /></ProtectedRoute>} />
        <Route path="/explorer" element={<ProtectedRoute><Explorer /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
        <Route path="/vrat" element={<ProtectedRoute><Vrat /></ProtectedRoute>} />
        <Route path="/enterprise" element={<ProtectedRoute><Enterprise /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="/learn" element={<ProtectedRoute><LearnYumo /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
